// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MediaCard__card___3awUx{min-height:350px;margin:0 20px;padding:32px 40px;border-radius:8px;background-color:#1b31a4;transition:opacity .4s ease-in .2s}.MediaCard__mediaLogo___TJ-wK{height:32px;margin-bottom:30px}.MediaCard__mediaContent___2JTds{color:inherit;font-weight:400;font-size:20px;line-height:32px}.MediaCard__link___4IOIE{display:flex;align-items:center;margin-top:24px;color:#acbef7;text-decoration:none}.MediaCard__link___4IOIE:hover{text-decoration:underline}.MediaCard__icon___y27G1{margin-right:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "MediaCard__card___3awUx",
	"mediaLogo": "MediaCard__mediaLogo___TJ-wK",
	"mediaContent": "MediaCard__mediaContent___2JTds",
	"link": "MediaCard__link___4IOIE",
	"icon": "MediaCard__icon___y27G1"
};
module.exports = ___CSS_LOADER_EXPORT___;
